package store.actions

import it.neckar.common.redux.ChangeType
import it.neckar.lizergy.comments.model.Comment
import kotlin.uuid.Uuid
import store.PlannerClientState

data class CommentAddedAction(val commentFor: Uuid, val newComment: Comment) : StateAction {
  override val type: ChangeType = ChangeType.HistoryReset

  override fun PlannerClientState.updateState(): PlannerClientState {
    return this.copy(
      allCommentsForComponents = allCommentsForComponents.withNewComment(commentFor, newComment),
    )
  }
}
